// 批阅表单配置项
import React from 'react'
import { component_tool } from '@/tool'
let { WizInputNumber, WizTypography, WizRow, WizCol, WizAntdForm } = component_tool

let { Item } = WizAntdForm
let { Paragraph, Title } = WizTypography

const scoreValidator = (rule, value, callback) => {
    if (value && Number(value) % 0.5 !== 0) {
        callback('分值需为0.5的倍数')
    }
    callback();
}

export default (parts) => {
    if (parts.length === 0) {
        return []
    }
    let mapColumns = parts.map((item, index) => {
        /**
         * score 单题分
         * size 题目数量
         * title 章节标题 string
         * questions 题目信息 arr
         */
        let { score, size, title, questions, id: partId } = item
        let obj = {
            formItem: {
                type: 'custom',
                render: (record, form) => {
                    const { getFieldDecorator } = form
                    let titleMsg = `${index + 1}.${title}(共${size}题, 每题${score}分, 共${size * score}分)`
                    return (
                        <>
                            <div className='review-chapter'>{titleMsg}</div>
                            {
                                questions.map((e, i) => {
                                    let { title: qTitle, id, answer, obtainScore, img } = e
                                    return (
                                        <div className='review-subject' key={id}>
                                            <WizRow type='flex' gutter={16}>
                                                <WizCol span={18}>
                                                    <Title className='review-subject-title'>
                                                        <span className='title-block-style'>{i + 1}</span>
                                                        {qTitle}
                                                    </Title>
                                                </WizCol>
                                                <WizCol span={6}>
                                                    <div className='subject-right-style'>
                                                        <Item className='subject-right-input'>
                                                            {
                                                                getFieldDecorator(String(id), {
                                                                    initialValue: (obtainScore || obtainScore === 0) && obtainScore >= 0 ? obtainScore : '',
                                                                    rules: [
                                                                        { required: true, message: '请输入分数', },
                                                                        {
                                                                            validator: scoreValidator
                                                                        }
                                                                    ],
                                                                    validateFirst: true,
                                                                })(
                                                                    <WizInputNumber max={score} min={0} step={1} />
                                                                )
                                                            }
                                                        </Item>
                                                        <span>分</span>
                                                    </div>
                                                </WizCol>
                                            </WizRow>
                                            {
                                                img ? <img src={getOssFilePath(img)} className='img-style' /> : null
                                            }
                                            <div className='answer-style'>
                                                <div className='answer-left-font'>
                                                    学员答案 ：
                                                </div>
                                                <Paragraph className='review-subject-info'>
                                                    {answer || '无'}
                                                </Paragraph>
                                            </div>
                                        </div>
                                    )

                                })
                            }
                        </>
                    )
                }
            },
        }
        return obj
    })
    return mapColumns
}